module.exports = __webpack_public_path__ + "static/IMG_7845_mobile-7bbf5c0111362955c1fe5fc34609ddd3.jpg";